export const ARTICLES = [
  {
    slug: "quel-site-internet-pour-un-artisan",
    title: "Quel site internet pour un artisan ?",
    seoTitle: "Quel site internet pour un artisan ? Guide pratique | Les Amis du Web",
    seoDescription:
      "Menuisier, plombier, peintre, rénovation… Quel site internet pour un artisan ? Contenu indispensable, erreurs à éviter, budget réel et exemple concret. Aperçu gratuit sans engagement.",
    category: "Conseils métier",
    date: "Juin 2026",
    readTime: "5 min",
    image: "/site-internet-renovation-interieure.webp",
    imageAlt: "Exemple de site internet créé pour une entreprise de rénovation intérieure",
    excerpt:
      "Le bouche-à-oreille ne suffit plus : vos futurs clients vérifient votre sérieux sur Google avant de vous appeler. Voici ce qu'un site internet d'artisan doit vraiment contenir.",
    sections: [
      {
        h2: "Pourquoi un artisan a besoin d'un site internet ?",
        paragraphs: [
          "Le bouche-à-oreille reste votre meilleur allié — mais il a changé de forme. Aujourd'hui, quand on vous recommande, le réflexe est de taper votre nom sur Google avant de vous appeler. Pas de site ? Le prospect doute. Un site vieillissant ? Il passe au concurrent suivant.",
          "Un site internet d'artisan n'a pas besoin d'être compliqué. Il doit rassurer, montrer votre travail et donner envie de demander un devis. C'est votre meilleur commercial : il travaille 24h/24, même quand vous êtes sur un chantier.",
        ],
      },
      {
        h2: "Ce que le site d'un artisan doit contenir",
        paragraphs: [
          "Inutile de multiplier les pages. Un bon site d'artisan repose sur quelques éléments essentiels :",
        ],
        list: [
          "Vos réalisations en photos — c'est la preuve n°1, idéalement avec des avant/après",
          "Vos prestations expliquées simplement, sans jargon",
          "Votre zone d'intervention (ville, département) — essentiel pour être trouvé localement sur Google",
          "Un formulaire de demande de devis simple et rapide",
          "Vos coordonnées visibles sur chaque page",
          "Ce qui vous différencie : garanties, assurance décennale, années de métier, labels",
        ],
      },
      {
        h2: "Les erreurs à éviter",
        paragraphs: [
          "La première erreur : le template générique. Un site qui ressemble à celui de milliers d'autres artisans n'inspire pas confiance et ne reflète pas la qualité de votre travail. La deuxième : des photos floues ou trop peu nombreuses — vos chantiers sont votre meilleur argument, montrez-les en grand et en haute qualité.",
          "Enfin, beaucoup de sites d'artisans oublient le mobile. Or vos clients vous cherchent le plus souvent depuis leur téléphone. Un site qui s'affiche mal sur mobile fait fuir — et Google le fait reculer dans les résultats.",
        ],
      },
      {
        h2: "Combien coûte un site internet d'artisan ?",
        paragraphs: [
          "Chez Les Amis du Web, la création complète d'un site sur mesure coûte 850 € (paiement unique), puis 65 € par mois pour l'hébergement, l'entretien et vos modifications. Vous ajoutez une réalisation, vous changez un tarif, vous ajoutez une prestation ? C'est inclus.",
          "Et surtout : avant de vous engager, nous créons gratuitement un aperçu de votre futur site, adapté à votre métier. Vous voyez le résultat, puis vous décidez.",
        ],
      },
      {
        h2: "Un exemple concret : Atelier Rénovation",
        paragraphs: [
          "Nous avons créé le site d'Atelier Rénovation, entreprise de rénovation intérieure : grandes photos de chantiers, comparateur avant/après, méthode expliquée en 4 étapes et demande de devis en ligne. Un design minéral et précis, à l'image du travail de l'artisan.",
        ],
        projectLink: "atelier-renovation",
      },
    ],
  },
  {
    slug: "quel-site-internet-pour-un-restaurant",
    title: "Quel site internet pour un restaurant ?",
    seoTitle: "Quel site internet pour un restaurant ? Guide pratique | Les Amis du Web",
    seoDescription:
      "Carte, réservation en ligne, photos, ambiance… Quel site internet pour un restaurant ? Ce qu'il doit contenir, les erreurs à éviter, le budget réel et un exemple concret. Aperçu gratuit sans engagement.",
    category: "Conseils métier",
    date: "Juin 2026",
    readTime: "5 min",
    image: "/creation-site-internet-restaurant.webp",
    imageAlt: "Exemple de site internet créé pour un restaurant gastronomique à La Rochelle",
    excerpt:
      "Avant de réserver une table, vos clients regardent votre site : la carte, les photos, l'ambiance. Un bon site de restaurant remplit la salle — voici comment.",
    sections: [
      {
        h2: "Pourquoi un restaurant a besoin d'un site internet ?",
        paragraphs: [
          "Le réflexe est systématique : avant de choisir un restaurant, on le cherche sur Google. On veut voir la carte, les photos de la salle et des plats, les horaires, et idéalement réserver en deux clics. Sans site — ou avec un site daté — vous perdez des tables tous les soirs au profit du restaurant d'à côté.",
          "Votre site est le prolongement de votre salle : il doit donner faim et donner envie de pousser la porte. C'est votre premier serveur — celui qui accueille les clients avant même leur arrivée.",
        ],
      },
      {
        h2: "Ce que le site d'un restaurant doit contenir",
        paragraphs: ["Un site de restaurant efficace tient en quelques éléments bien exécutés :"],
        list: [
          "La réservation de table en ligne — c'est LA fonctionnalité qui remplit la salle",
          "La carte et les menus, à jour et lisibles sur téléphone",
          "De grandes photos des plats et de la salle, en haute qualité",
          "L'histoire du lieu et du chef — c'est ce qui crée l'attachement",
          "Les horaires, l'adresse et l'itinéraire, visibles immédiatement",
          "Les informations pratiques : privatisation, groupes, allergènes",
        ],
      },
      {
        h2: "Les erreurs à éviter",
        paragraphs: [
          "L'erreur la plus fréquente : la carte en PDF, illisible sur mobile — la majorité de vos visiteurs consultent votre site depuis leur téléphone, souvent dans la rue, juste avant de choisir. Deuxième erreur : des photos sombres ou amateurs qui desservent votre cuisine. Un plat mal photographié fait fuir, même s'il est excellent.",
          "Enfin, l'ambiance du site doit correspondre à celle du restaurant. Un gastronomique mérite un univers feutré et élégant ; une brasserie, quelque chose de plus vivant. Un template générique ne raconte rien — et vos clients le sentent.",
        ],
      },
      {
        h2: "Combien coûte un site internet de restaurant ?",
        paragraphs: [
          "Chez Les Amis du Web, la création complète d'un site sur mesure coûte 850 € (paiement unique), puis 65 € par mois pour l'hébergement, l'entretien et vos modifications — changement de carte compris. Vous mettez à jour vos menus aussi souvent que nécessaire, sans surcoût.",
          "Et avant tout engagement, nous créons gratuitement un aperçu de votre futur site, adapté à votre cuisine et à votre ambiance. Vous voyez le résultat, puis vous décidez.",
        ],
      },
      {
        h2: "Un exemple concret : L'Essence",
        paragraphs: [
          "Nous avons créé le site de L'Essence, restaurant gastronomique à La Rochelle : univers sombre et feutré, grandes photos immersives, carte interactive et réservation de table en ligne. Chaque détail retranscrit l'expérience de la salle — avant même d'y entrer.",
        ],
        projectLink: "essence",
      },
    ],
  },
  {
    slug: "quel-site-internet-pour-un-salon-de-coiffure",
    title: "Quel site internet pour un salon de coiffure ?",
    seoTitle: "Quel site internet pour un salon de coiffure ? Guide pratique | Les Amis du Web",
    seoDescription:
      "Prise de rendez-vous en ligne, avant/après, prestations et tarifs… Quel site internet pour un salon de coiffure ? Contenu essentiel, erreurs à éviter, budget réel et exemple concret. Aperçu gratuit sans engagement.",
    category: "Conseils métier",
    date: "Juin 2026",
    readTime: "5 min",
    image: "/creation-site-internet-coiffeur.webp",
    imageAlt: "Exemple de site internet créé pour un salon de coiffure haut de gamme à Paris",
    excerpt:
      "Vos clientes choisissent leur salon sur Instagram et Google avant de pousser la porte. Un site élégant avec prise de rendez-vous en ligne fait toute la différence.",
    sections: [
      {
        h2: "Pourquoi un salon de coiffure a besoin d'un site internet ?",
        paragraphs: [
          "La coiffure est un métier d'image : avant de confier leurs cheveux à quelqu'un, vos futures clientes veulent voir votre travail, votre salon et vos tarifs. Elles vous découvrent sur Instagram ou Google — et c'est votre site qui transforme cette curiosité en rendez-vous.",
          "Un site de salon de coiffure a un objectif simple : remplir votre agenda. Chaque visite doit pouvoir se terminer par une prise de rendez-vous, à toute heure, même quand le salon est fermé.",
        ],
      },
      {
        h2: "Ce que le site d'un salon de coiffure doit contenir",
        paragraphs: ["Voici les éléments qui font réellement la différence :"],
        list: [
          "La prise de rendez-vous en ligne — vos clientes réservent le soir, le dimanche, entre deux réunions",
          "Une galerie avant/après : la preuve de votre savoir-faire, plus convaincante que n'importe quel texte",
          "La carte des prestations avec les tarifs, claire et sans surprise",
          "L'ambiance du salon en photos : décoration, fauteuils, lumière — on choisit aussi un lieu",
          "L'équipe et ses spécialités (coloration, balayage, soins…)",
          "Les horaires, l'adresse et un accès rapide depuis mobile",
        ],
      },
      {
        h2: "Les erreurs à éviter",
        paragraphs: [
          "Première erreur : cacher les tarifs. L'absence de prix fait hésiter, surtout pour un premier rendez-vous. Deuxième erreur : des photos qui ne reflètent pas votre niveau — pour un salon haut de gamme, des visuels amateurs cassent immédiatement le positionnement.",
          "Enfin, l'esthétique du site doit prolonger celle du salon. Si votre salon est chaleureux et élégant, votre site doit l'être aussi : typographies raffinées, couleurs douces, matières chaudes. Un template impersonnel ne transmet rien de votre univers.",
        ],
      },
      {
        h2: "Combien coûte un site internet de salon de coiffure ?",
        paragraphs: [
          "Chez Les Amis du Web, la création complète d'un site sur mesure coûte 850 € (paiement unique), puis 65 € par mois pour l'hébergement, l'entretien et vos modifications — nouvelle prestation, changement de tarif ou nouvelles photos comprises.",
          "Et avant tout engagement, nous créons gratuitement un aperçu de votre futur site, adapté à l'univers de votre salon. Vous voyez le résultat, puis vous décidez.",
        ],
      },
      {
        h2: "Un exemple concret : L'Atelier",
        paragraphs: [
          "Nous avons créé le site de L'Atelier, maison de beauté parisienne haut de gamme : ambiance tamisée et dorée, galerie avant/après, carte des prestations et prise de rendez-vous en ligne. Le site respire le même luxe que le salon lui-même.",
        ],
        projectLink: "atelier-coiffure",
      },
    ],
  },
  {
    slug: "quel-site-internet-pour-une-location-saisonniere",
    title: "Quel site internet pour une location saisonnière ?",
    seoTitle: "Quel site internet pour une location saisonnière ? Guide pratique | Les Amis du Web",
    seoDescription:
      "Villa, gîte, maison d'hôtes… Quel site internet pour une location saisonnière ? Réservation en direct sans commission, photos immersives, budget réel et exemple concret. Aperçu gratuit sans engagement.",
    category: "Conseils métier",
    date: "Juin 2026",
    readTime: "5 min",
    image: "/site-internet-villa-location.webp",
    imageAlt: "Exemple de site internet créé pour une villa de location face à l'océan",
    excerpt:
      "Airbnb et Booking prélèvent jusqu'à 20 % de commission sur chaque séjour. Un site dédié à votre location vous rend votre indépendance — et vos marges.",
    sections: [
      {
        h2: "Pourquoi une location saisonnière a besoin de son propre site ?",
        paragraphs: [
          "Les plateformes comme Airbnb ou Booking sont utiles pour se lancer — mais elles ont un coût : des commissions importantes sur chaque réservation, aucune relation directe avec vos voyageurs et une fiche standardisée noyée parmi des milliers d'autres.",
          "Un site internet dédié change la donne : les voyageurs réservent en direct, vous gardez la totalité du montant du séjour, et surtout vous construisez une vraie image. Une belle villa mérite mieux qu'une fiche : elle mérite un univers.",
        ],
      },
      {
        h2: "Ce que le site d'une location saisonnière doit contenir",
        paragraphs: ["Les éléments qui déclenchent une réservation en direct :"],
        list: [
          "Une visite immersive du lieu : grandes photos lumineuses, pièce par pièce",
          "Le calendrier des disponibilités, à jour",
          "Une demande de réservation simple et rapide",
          "Les atouts du lieu : vue, piscine, plage, équipements, capacité",
          "Les environs : que faire, où manger, comment venir",
          "Une version anglaise si vous accueillez une clientèle internationale",
        ],
      },
      {
        h2: "Les erreurs à éviter",
        paragraphs: [
          "Première erreur : des photos sombres ou prises au téléphone. Pour une location, la photo EST le produit — les voyageurs réservent ce qu'ils voient. Deuxième erreur : un calendrier absent ou pas à jour, qui génère des allers-retours par email et fait fuir les voyageurs pressés.",
          "Enfin, ne copiez pas le style des plateformes : votre site doit faire vivre l'expérience du lieu. Une villa face à l'océan appelle un univers clair et solaire ; un chalet de montagne, une ambiance chaleureuse. C'est cette immersion qui donne envie de réserver en direct.",
        ],
      },
      {
        h2: "Combien coûte un site de location saisonnière ?",
        paragraphs: [
          "Chez Les Amis du Web, la création complète d'un site sur mesure coûte 850 € (paiement unique), puis 65 € par mois pour l'hébergement, l'entretien et vos modifications — mise à jour des photos, des tarifs ou des disponibilités comprise. À comparer aux commissions prélevées par les plateformes : le site est souvent rentabilisé en quelques réservations directes.",
          "Et avant tout engagement, nous créons gratuitement un aperçu de votre futur site, adapté à votre lieu. Vous voyez le résultat, puis vous décidez.",
        ],
      },
      {
        h2: "Un exemple concret : Villa Azur",
        paragraphs: [
          "Nous avons créé le site de Villa Azur, maison de location face à l'océan sur l'Île de Ré : visite immersive pièce par pièce, journée type illustrée, calendrier des disponibilités et réservation en direct, le tout en français et en anglais. Une parenthèse privée — qui commence dès la première seconde sur le site.",
        ],
        projectLink: "villa-azur",
      },
    ],
  },
  {
    slug: "quel-site-internet-pour-un-plombier",
    title: "Quel site internet pour un plombier ?",
    seoTitle: "Quel site internet pour un plombier ? Guide pratique | Les Amis du Web",
    seoDescription:
      "Dépannage, devis gratuit, avant/après, zone d'intervention… Quel site internet pour un plombier ? Contenu essentiel, erreurs à éviter, budget réel et exemple concret. Aperçu gratuit sans engagement.",
    category: "Conseils métier",
    date: "Juin 2026",
    readTime: "5 min",
    image: "/creation-site-internet-plombier.webp",
    imageAlt: "Exemple de site internet créé pour un plombier à La Rochelle",
    excerpt:
      "Une fuite, un chauffe-eau en panne : vos clients vous cherchent sur Google dans l'urgence. Le plombier qu'ils trouvent — et qui inspire confiance — décroche le chantier.",
    sections: [
      {
        h2: "Pourquoi un plombier a besoin d'un site internet ?",
        paragraphs: [
          "La plomberie est un métier d'urgence : quand une fuite se déclare, le client tape « plombier + sa ville » sur Google et appelle le premier artisan qui lui inspire confiance. Sans site internet, vous n'existez pas dans cette recherche. Avec un site daté, vous perdez l'appel au profit du concurrent.",
          "Un site de plombier a deux missions : être trouvé localement, et déclencher l'appel ou la demande de devis en quelques secondes. Tout le reste est secondaire.",
        ],
      },
      {
        h2: "Ce que le site d'un plombier doit contenir",
        paragraphs: ["Les éléments qui déclenchent réellement un appel :"],
        list: [
          "Un bouton d'appel en un clic, visible en permanence sur mobile",
          "La demande de devis gratuit, simple et rapide",
          "Vos interventions en avant/après : la preuve du travail bien fait",
          "La liste claire de vos services : dépannage, fuite, débouchage, chauffe-eau, sanitaire, rénovation",
          "Votre zone d'intervention, ville par ville — essentiel pour le référencement local",
          "Des éléments de réassurance : devis clair, travail garanti, artisan qualifié",
        ],
      },
      {
        h2: "Les erreurs à éviter",
        paragraphs: [
          "Première erreur : cacher le numéro de téléphone. Le client en urgence veut appeler tout de suite — chaque clic supplémentaire vous coûte des chantiers. Deuxième erreur : oublier le mobile, alors que l'immense majorité des recherches « plombier près de chez moi » se font depuis un téléphone.",
          "Enfin, méfiez-vous des sites impersonnels : le client confie sa maison à un inconnu, il a besoin de voir un vrai artisan, de vrais chantiers, une vraie zone d'intervention. Les photos génériques et les promesses vagues font fuir.",
        ],
      },
      {
        h2: "Combien coûte un site internet de plombier ?",
        paragraphs: [
          "Chez Les Amis du Web, la création complète d'un site sur mesure coûte 850 € (paiement unique), puis 65 € par mois pour l'hébergement, l'entretien et vos modifications — nouveaux chantiers en avant/après, tarifs ou zone d'intervention compris. Un seul chantier décroché grâce au site suffit souvent à le rentabiliser.",
          "Et avant tout engagement, nous créons gratuitement un aperçu de votre futur site, adapté à votre activité. Vous voyez le résultat, puis vous décidez.",
        ],
      },
      {
        h2: "Un exemple concret : Aqua Pro",
        paragraphs: [
          "Nous avons créé le site d'Aqua Pro, plombier à La Rochelle : appel en un clic, devis gratuit en ligne, avant/après interactifs des chantiers, zone d'intervention détaillée, FAQ et avis clients. Un design bleu profond, professionnel et rassurant — pensé pour transformer l'urgence en appel.",
        ],
        projectLink: "aqua-pro-plombier",
      },
    ],
  },
];
